/* src/app/pages/agents/create-agent-modal/create-agent-modal.component.scss */
.template-card {
  border: 1px solid #e9ecef;
  border-radius: 0.375rem;
  padding: 1.5rem;
  cursor: pointer;
  transition: all 0.15s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.template-card:hover {
  border-color: var(--primary);
  transform: translateY(-1px);
}
.template-card.selected {
  border-color: var(--primary);
  background-color: rgba(var(--primary-rgb), 0.05);
}
.template-card .icon {
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  background-color: var(--primary);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
  font-size: 1.25rem;
}
.template-card h5 {
  margin: 0;
  font-size: 1rem;
  font-weight: 500;
}
.form-group {
  margin-bottom: 1.5rem;
}
.form-group label {
  font-size: 0.875rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}
.modal-body {
  padding: 1.5rem;
}
.modal-footer {
  padding: 1rem 1.5rem;
  background-color: #f6f9fc;
}
/*# sourceMappingURL=create-agent-modal.component.css.map */
